import { TZDate } from '@date-fns/tz';
import { useAppointmentRecord } from '@entities/appointment/api/useAppointmentRecord';
import { queryClient } from '@shared/api/query-client';
import { TimeDisplay } from '@shared/ui/time-display/time-display';
import { IconChevronLeft } from '@tabler/icons-react/dist/cjs/tabler-icons-react';
import React from 'react'
import { useNavigate } from 'react-router-dom';
import useMedia from 'use-media';
import { VideoConf } from '../video-conf/video-conf';
import s from './conference-card.module.scss'

export const ConferenceCard = ({appointmentId, appointment, status, isConf, setIsConf, shouldRequest, isTeacher, setMode, setIsBottomSheetShown}) => {
	const {data: profile} = queryClient.getQueryData(['profile'])
	const isMobile = useMedia({ maxWidth: "768px" });
	const navigate = useNavigate();

	const date = new TZDate(appointment?.starts_at, profile?.timezone);
	const dateEnd = new TZDate(appointment?.ends_at, profile?.timezone);
	const today = new Date();

	const isToday =
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear();
  const confIsStart = today.getTime() >= date.getTime() && today.getTime() < dateEnd?.getTime();
  const confIsEnd = dateEnd?.getTime() < today?.getTime();


	const { data: appointmentRecord } = useAppointmentRecord(confIsEnd ? appointmentId : null)
		
		const disabled = status === "pending" || status === "error";

	return (
		<div className={s.conferenceCard}>
			{isConf || <div className={s.conferenceHeader}>
				<div className={s.title}>
					{isMobile && (
						<button className={s.backToList} onClick={() => navigate(-1)}>
							<IconChevronLeft />
						</button>
					)}
					{isMobile || <span className={s.titleText}>
						Занятие
					</span>}
				</div>
				<div className={s.timer}>
					{confIsEnd ? (
						"Завершено"
					) : isToday ? (
						confIsStart ? (
							<TimeDisplay startsAt={date} />
						) : (
							<>
								Начнется в{" "}
								{date.toLocaleString("ru-RU", {
									hour: "2-digit",
									minute: "2-digit",
								})}
							</>
						)
					) : (
						date.toLocaleDateString("ru-RU", { formatMatcher: "basic" })
					)}
				</div>
			</div>}
			<VideoConf
				{...{
					isConf,
					setIsConf,
					shouldRequest,
					appointmentRecord,
					disabled,
					confIsEnd,
					startsAt: appointment?.starts_at,
					appointment,
					isTeacher,
					onOpenMaterials: () => {
						setMode(0);
						if (isMobile) {
							setIsBottomSheetShown(true);
						}
					},
				}}
			/>
		</div>
	)
}
